import { AI_FILTER } from '@modules/common/constants';
import {
  EqlFieldValueType,
  ObjectType,
  QueryBuilderGroup,
  QueryBuilderGroupType,
} from 'generated/graphql';

export function getAIFilterGroup(prompt?: string) {
  const aiFilterGroup: QueryBuilderGroup = {
    displayName: 'Generate filter with Wisdom',
    hasMore: false,
    id: AI_FILTER,
    options: [
      {
        field: {
          displayName: prompt
            ? 'Generate filter with Wisdom'
            : 'Write a prompt to generate filters...',
          field: AI_FILTER,
          isMultiValue: false,
          objectType: ObjectType.Feedback,
          valueType: EqlFieldValueType.String,
        },
        value: prompt
          ? {
              displayName: prompt,
              value: prompt,
            }
          : undefined,
        isCompleteMatch: false,
      },
    ],
    type: QueryBuilderGroupType.Field,
  };

  return aiFilterGroup;
}
